import React from 'react';
import { UserProfile, Tenant, Role } from '../types';
import { PlatformAdminView } from './admin/PlatformAdminView';
import { PartnerAdminView } from './admin/PartnerAdminView';
import { TenantAdminView } from './admin/TenantAdminView';

interface AdminConsoleProps {
  userProfile: UserProfile;
  tenant: Tenant;
  onExitAdmin: () => void;
  updateTenant: (updatedTenant: Tenant) => void;
}

export const AdminConsole: React.FC<AdminConsoleProps> = ({ userProfile, tenant, onExitAdmin, updateTenant }) => {
  const renderAdminViewForRole = () => {
    switch (userProfile.role) {
      case Role.PLATFORM_ADMIN:
        return <PlatformAdminView userProfile={userProfile} tenant={tenant} />;
      case Role.PARTNER_ADMIN:
        return <PartnerAdminView userProfile={userProfile} tenant={tenant} />;
      case Role.TENANT_ADMIN:
        return <TenantAdminView userProfile={userProfile} tenant={tenant} updateTenant={updateTenant} />;
      default:
        return <p>You do not have administrative privileges.</p>;
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-6 md:p-8 font-raleway text-brand-grey">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-6 bg-white p-4 rounded-lg shadow-sm border border-gray-200">
          <div>
              <h1 className="text-2xl md:text-3xl font-bold">Admin Console</h1>
              <p className="text-sm text-gray-500">{userProfile.role.replace('_', ' ')} View</p>
          </div>
         <button
  type="button"
  onClick={onExitAdmin}
  className="text-sm text-brand-orange hover:underline"
>
  ← Back to App
</button>



        </div>
        
        {renderAdminViewForRole()}
      </div>
    </div>
  );
};